import React, { useState, useCallback, useEffect } from "react";
import Layout from "./Layout";
import { db } from "../../../config/firebase";
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  doc,
} from "firebase/firestore";
import useTableFunction from "../../../hooks/useTableFunction";
import { COLLECTION } from "../../../data/constant";

export default function UserManagement() {
  // Existing user table logic
  const {
    tableData,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
  } = useTableFunction({
    collectionPath: COLLECTION.USER,
  });

  // Recharge offers state
  const [offers, setOffers] = useState([]);
  const [offerModalOpen, setOfferModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingOfferId, setEditingOfferId] = useState(null);
  const [offerForm, setOfferForm] = useState({
    rechargeAmount: "",
    walletAmount: "",
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
  });

  // Fetch offers (stable with useCallback to avoid infinite loop)
  const fetchOffers = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "RechargeOffers"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setOffers(list);
    } catch (error) {
      console.error("Error fetching offers:", error);
    }
  }, []);

  useEffect(() => {
    fetchOffers();
  }, [fetchOffers]);

  // Handle input changes
  const handleOfferInputChange = (e) => {
    const { name, value } = e.target;
    setOfferForm((prev) => ({ ...prev, [name]: value }));
  };

  // Create or update offer
  const handleSaveOffer = async () => {
    try {
      if (isEditing) {
        await updateDoc(doc(db, "RechargeOffers", editingOfferId), offerForm);
      } else {
        await addDoc(collection(db, "RechargeOffers"), offerForm);
      }
      setOfferForm({
        rechargeAmount: "",
        walletAmount: "",
        startDate: new Date().toISOString().split("T")[0],
        endDate: new Date().toISOString().split("T")[0],
      });
      setIsEditing(false);
      setEditingOfferId(null);
      fetchOffers();
    } catch (error) {
      console.error("Error saving offer:", error);
    }
  };

  // Edit existing offer
  const handleEditOffer = (offer) => {
    setOfferForm({
      rechargeAmount: offer.rechargeAmount,
      walletAmount: offer.walletAmount,
      startDate: offer.startDate,
      endDate: offer.endDate,
    });
    setIsEditing(true);
    setEditingOfferId(offer.id);
  };

  // Delete offer
  const handleDeleteOffer = async (id) => {
    try {
      await deleteDoc(doc(db, "RechargeOffers", id));
      fetchOffers();
    } catch (error) {
      console.error("Error deleting offer:", error);
    }
  };

  return (
    <Layout
      // Existing user table props
      userTableData={tableData}
      isTableLoading={isTableLoading}
      currentPage={currentPage}
      totalLength={totalLength}
      handlePageChange={handlePageChange}
      handlePageSize={handlePageSize}
      handleSearchQuery={handleSearchQuery}
      handleTableSorting={handleTableSorting}

      // New recharge offers props
      offers={offers}
      offerModalOpen={offerModalOpen}
      setOfferModalOpen={setOfferModalOpen}
      offerForm={offerForm}
      handleOfferInputChange={handleOfferInputChange}
      handleSaveOffer={handleSaveOffer}
      handleEditOffer={handleEditOffer}
      handleDeleteOffer={handleDeleteOffer}
      isEditing={isEditing}
    />
  );
}
